import React, { useContext, useState, useEffect } from "react";
import HistoryTable from "./HistoryTable";
import axios from "axios";
// Import react-circular-progressbar module and styles
import {
  CircularProgressbar,
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import contractdata from '../../contract.json'
// Animation
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "./AnimatedProgressProvider";
import ChangingProgressProvider from "./ChangingProgressProvider";
import { ethers } from "ethers";
// Radial separators
import RadialSeparators from "./RadialSeparators";
import StakeModal from "../Coman/StakeModal";
import ClaimModal from "../Coman/ClaimModal";
import Faq from "./Faq";
import Timer from "../Coman/Timer";
import { ProjectContext } from "../../ProjectContext";
import { BigNumber } from "ethers";
import TeamTable from "./TeamTable";
import BonanzaReward from "./BonanzaReward";
import DailyyieldTable from "./DailyyieldTable";
import TeamyieldTable from "./TeamyieldTable";
import ClaimTable from "./ClaimTable";
import { useConnectModal } from "@rainbow-me/rainbowkit";
import SwapTable from "./SwapTable";

function DashboardMain() {

  const {
    account,
    toastSuccess,
    library,
    toastError,
    settings,
    esigner,
    ethers,
    getuserDB,
    x2balance,
    Refaddress,
    dbbalance,
    copyaddress, dbuser, formatAddress, dbuserx1, usertnx, Dbalance, swap_contract,
    dbReward, usertnxDate, Earnig, Team, getsmcs, DefinRate, Ubalance, DailyReward, useractivestatus, Maincontract, Defincontract, NextCxDate, Claimed,
  } = useContext(ProjectContext)

  // console.log("user data---------->", dbuser);

  function getFormattedDate(timestamp) {
    // Convert timestamp (assuming it is in seconds, hence multiplying by 1000)
    const date = new Date(Number(timestamp) * 1000);

    // Extract components
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed, so we add 1
    const day = String(date.getDate()).padStart(2, '0');
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    // Format in YYYY-MM-DDTHH:MM:SS format
    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }
  const currentTimestampInSeconds = Math.floor(Date.now() / 1000);

  // console.log("currentTimestamp", currentTimestampInSeconds); // This will log the current timestamp

  // Usage
  const formattedDateTime = getFormattedDate(usertnxDate);
  const formattedNextClaimDateTime = getFormattedDate(NextCxDate);
  console.log("formattedNextClaimDateTime", formattedNextClaimDateTime);

  const formattedCDateTime = getFormattedDate(currentTimestampInSeconds);

  // console.log("formattedDateTime", formattedDateTime, "curruntdate---->", formattedCDateTime);
  // console.log("dbuser", dbuser);
  const normalizedValue = dbuserx1 === 0 ? 0 : (dbReward / dbuserx1) * 100;
  // console.log("normalizedValue", dbuserx1);
  var balance = DefinRate * Dbalance
  const [showtab, setShowTab] = useState(0);
  const [data, setdata] = useState({ levelsIncome: {}, bonanzaRewards: [] });
  const [settled, setsettled] = useState(false);
  const [setting, setsetting] = useState([]);
  const [trdone, setTrdone] = useState(false);
  const [hash, setHash] = useState("");
  const [loading, setLoading] = useState(false);
  const { openConnectModal } = useConnectModal();
  const [amount, setAmount] = useState(20.78);
  const [Defin, setDefin] = useState(Dbalance);
  console.log("DAA", amount, Number(amount).toFixed(0).toString());

  const onDeposit = async () => {
    setTrdone(true);
    setHash("");
    setLoading(true);

    if (!account) {
      openConnectModal();
      toastError("Connect wallet first");
      setTrdone(false);
      setLoading(false);
      return;
    }

    try {
      // const provider = new ethers.providers.Web3Provider(window.ethereum);
      // const signer = provider.getSigner();


      // setAmount(Dbalance);
      console.log("DAA", Dbalance, amount, Number(amount).toFixed(0).toString());

      const amountInWei = ethers.utils.parseUnits(Number(amount).toFixed(0).toString(), 18);

      const allowance = await Defincontract.allowance(account, settings.swap);
      console.log("Allowance:", amountInWei.toString(), allowance.lt(amountInWei.toString()));

      if (allowance.lt(amountInWei.toString())) {
        const approveTx = await Defincontract.approve(settings.swap, amountInWei.toString());
        await approveTx.wait();
        toastSuccess("✅ Token Approved");
      }

      const tx = await swap_contract.depositToken();
      const receipt = await tx.wait();
      try {
        const res = await axios.post(process.env.REACT_APP_BACKEND_LINK, {
          method: "withdrawal",
          submethod: "add",
          address: account,
          amount: amount,
          hash: receipt.transactionHash,
          key: process.env.REACT_APP_KEY,
        });
        if (!res.data.error) {
          toastSuccess("Transaction done");
          console.log("Transaction", res);
          setAmount(0);
          getsmcs();
        } else {
          toastError(`${res.data.error}`);
          console.log("Transaction failed", res.data.error);
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      }
      toastSuccess("🚀 Deposit Successful");
    } catch (error) {
      console.error("Deposit error:", error);
      toastError(`❌ ${error?.data?.message || error.message}`);
    } finally {
      setTrdone(false);
      setLoading(false);
    }
  };

    const getuserData = async () => {
    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "user",
        submethod: "getbyid",
        username: account,
        key: process.env.REACT_APP_KEY,
      })
      .then((res) => {
        if (res.data.error) {
          return "";
        }
        if(res.data.data.isSettled == true)
        {
          setsettled(true);
        }
        console.log("NEW API",res.data, res.data.data.isSettled);
      });
  };

  const getData = async () => {
    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "dailyreward",
        submethod: "get",
        userAddress: account,
        key: process.env.REACT_APP_KEY,
      })
      .then((res) => {
        if (res.data.error) {
          return "";
        }
        setdata(res.data); // Set the full response data (levelsIncome and bonanzaRewards)
      });
  };
  const getSetting = async () => {
    await axios
      .post(process.env.REACT_APP_BACKEND_LINK, {
        method: "setting",
        submethod: "get",
        key: process.env.REACT_APP_KEY,
      })
      .then((res) => {
        if (res.data.error) {
          return "";
        }
        setsetting(res.data.data); // Set the full response data (levelsIncome and bonanzaRewards)
      });
  };
  useEffect(() => {
      getuserData()
    getData();
    getSetting();
    setAmount(Dbalance);
  }, [Dbalance, swap_contract]);
  return (
    <div>
      <div className="content-body">
        {/* row */}
        <div className="container">
          <div className="row">
            <div className="col-xl-12 ">
              {/* <div className="col-12 text-center">
                <h3 className="blink_me text-danger">Technical update is successfully completed.</h3>
                <p className="blink_me text-danger">We'll be back online on 15th April at 06:30 AM UTC.</p>
                <p className="blink_me text-danger">Thank you for your patience and support!</p>
            </div> */}
              {/*    <h2 className="fw-bold">We have  moved our liquidity from the BEP20 network to the Arbitrum chain.</h2>
              <p className="text-danger">Please be patient — the platform will be back online within approximately 3 hours.</p>
              <p className="text-danger"> Thank you for your understanding and support.</p> */}
              <div className="card  bg-box-1">
                <div className="card-body py-2">
                  <div className="d-flex justify-content-between align-items-center flex-wrap">

                    <span class="badge c-pointer  rounded-pill me-2 d-flex justify-content-between align-items-center shadow-1 p-2 my-2">
                      <span class="badge light badge-light text-dark fs-15">
                        <i class="fa fa-user-plus"></i>
                      </span>
                      <small className="ms-2 me-4 fw-light fs-15">Team :</small>
                      <span class="badge light  badge-light text-dark rounde-5 fs-15">
                        {Team ? Team : "--"}
                      </span>
                    </span>
                    <span class="badge c-pointer rounded-pill me-2 d-flex justify-content-between align-items-center shadow-1 p-2 my-2">
                      <small
                        className="ms-1 fs-15 me-2 fw-light"
                        onClick={() => copyaddress(`${process.env.REACT_APP_URL}${dbuser?.address}`)}
                      >
                        Copy Referral Link
                      </small>
                    </span>
                    <span class="badge c-pointer rounded-pill me-2 d-flex justify-content-between align-items-center shadow-1 my-2">
                      <span class="badge light badge-success fs-15">
                        <i class="fa fa-usd"></i>
                      </span>
                      <small className="ms-1 me-2 fw-light fs-15 ">
                        Earning :
                      </small>
                      <b className="fs-18"> {Earnig ? "$" + Earnig : "--"}</b>
                    </span>
                    <span class="badge c-pointer rounded-pill me-2 d-flex justify-content-between align-items-center shadow-1 my-2">
                      <b className="fs-18">{DefinRate ? "$" + DefinRate : "--"}</b>
                    </span>
                    <button className="text-white btn-outline-bg-new-primary py-1 px-3" onClick={() => getsmcs()}><i className="fa fa-refresh"></i></button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row align-items-center">
            <div className="col-12 text-center">
                {settled === true ? <h3 className="text-success">Your account is settled.</h3> : ""}
              <p className="blink_me text-danger">{normalizedValue > 75 ? "Your next restake will be available shortly. Keep going!" : ""}</p>
              <p className="my-0">Your Account Balance</p>
              <h3 className="fw-bold"> ${balance.toFixed(2)} ({Number(Dbalance).toFixed(2)} {process.env.REACT_APP_TOKEN_TICKER})</h3>

              <button
                onClick={onDeposit}
                disabled={loading}
                className="badge bg-black mt-4 rounded-pill me-2 c-pointer align-items-center shadow-5 p-2 my-2"
              >
                <small className="ms-1 fs-20 me-2 fw-light text-center">
                  {loading ? "Processing..." : "Swap"}
                </small>
              </button>
            </div>
            {/*<div className="col-12">
              <iframe
                src="https://www.dextools.io/widget-chart/en/bnb/pe-light/0xde2505f91d577e1303b8ed62658d3081b7109c8e?theme=dark&chartType=0&chartResolution=10&drawingToolbars=false&tvPlatformColor=000000&tvPaneColor=ffffff&headerColor=000000&chartInUsd=true"
                width="100%"
                height="500px"
                frameBorder="0"
                allowfullscreen
                title="DEXTools Chart"
              />
            </div> */}
            <div className=" col-xl-4 ">
              <div className="card  bg-box-1">
                <div className="card-header d-block pb-0 border-0">

                  <div>
                    {/* <div className="d-flex justify-content-between flex-wrap align-items-center">
                      <h4 className="fs-20 text-white"> Account</h4>
                      <h4 className=" text-white">
                        {formatAddress(dbuser?.address)}{" "}
                        <i className="fa fa-copy ms-2  c-pointer" onClick={() => copyaddress(dbuser?.address)} />
                      </h4>{" "}
                    </div>
                    <div className="d-flex justify-content-between flex-wrap align-items-center">
                      <h4 className="fs-20 text-white"> Referral</h4>

                      <h4 className=" text-white">
                        {formatAddress(dbuser?.ref_address)}{" "}
                        <i className="fa fa-copy ms-2 c-pointer" onClick={() => copyaddress(dbuser?.ref_address)} />
                      </h4>
                    </div> */}
                    <div className="d-flex justify-content-between flex-wrap align-items-center">
                      <h4 className="fs-20 text-white"> Account</h4>
                      <h4 className=" text-white">
                        {formatAddress(account)}{" "}
                        <i className="fa fa-copy ms-2  c-pointer" onClick={() => copyaddress(account)} />
                      </h4>{" "}
                    </div>
                    <div className="d-flex justify-content-between flex-wrap align-items-center">
                      <h4 className="fs-20 text-white"> Referral</h4>

                      <h4 className=" text-white">
                        {formatAddress(dbuser?.ref_address)}{" "}
                        <i className="fa fa-copy ms-2 c-pointer" onClick={() => copyaddress(dbuser?.ref_address)} />
                      </h4>
                    </div>
                  </div>
                  <br />
                  {/* <div className="d-flex justify-content-between">
                    <h4 className=" text-white">
                      0xbcc52...DD0c4 <i className="fa fa-copy me-1"></i>
                    </h4>
                    <h6 className=" text-white">
                      <i className="fa fa-check-circle me-1"></i>Connected
                    </h6>
                  </div> */}
                </div>
                <div
                  className="card-body d-flex justify-content-center pt-0"
                  style={{ height: "250px" }}
                >
                  <div style={{ width: "250px", height: "250px" }}>
                    <CircularProgressbarWithChildren
                      value={normalizedValue} // Current progress as percentage of max value
                      text={dbuser?.address !== '0x0000000000000000000000000000000000000000' && dbuser !== null ? `${normalizedValue.toFixed(2)}%` : "-"} // Show percentage text
                      strokeWidth={8}
                      circleRatio={0.75}
                      styles={buildStyles({
                        strokeLinecap: "butt",
                        rotation: 1 / 2 + 1 / 8,
                        pathColor: "#246bdd", // Progress bar color
                        trailColor: "#e0e0e0", // Trail (background) color
                        textColor: "#246bdd", // Text color
                      })}
                    >
                      {/* Radial Separators */}
                      <RadialSeparators
                        count={dbuserx1} // Number of radial separators, based on dbuserx1
                        style={{
                          background: "#000",
                          width: "2px",
                          height: `${10}%`, // Height of each separator
                        }}
                      />
                      <p className="text-white text-reward text-center">
                        Total Reward <br />
                        {dbReward ? "$" + dbReward.toFixed(2) : "--"}
                      </p>
                    </CircularProgressbarWithChildren>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-8">
              <div className="row ">
                {" "}
                <div className="col-md-6 col-xl-6 mt-lg-3">
                {/*<span
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModalCenter"
                    className="badge bg-black rounded-pill me-2 text-center c-pointer d-flex justify-content-center align-items-center shadow-5 p-2 my-2"
                  >
                    {
                      (dbuser?.address !== "0x0000000000000000000000000000000000000000")
                        ? (formattedDateTime !== 0 && formattedCDateTime >= formattedDateTime)
                          ? (
                            <small className="ms-1 fs-20 me-2 fw-light text-center text-danger blink_me">
                              !! Restake Now !!
                            </small>
                          )
                          : (
                            <small className="ms-1 fs-20 me-2 fw-light text-center">
                              Stake
                            </small>
                          )
                        : (
                          <small className="ms-1 fs-20 me-2 fw-light text-center">
                            Stake
                          </small>
                        )
                    }
                  </span> */}
                  {useractivestatus ? <>
                    <h3>Restake Now</h3>
                  </>
                    :
                    <>
                      {settled === true || dbbalance === 1

                        ? <span
                          className="badge bg-black mt-4 rounded-pill me-2 d-flex justify-content-center c-pointer align-items-center shadow-5 p-2 my-2"
                        >
                          <small className="ms-1 fs-20 me-2 fw-light text-center">
                            Claim
                          </small>
                        </span>
                        :
                        <span
                          data-bs-toggle="modal"
                          data-bs-target="#exampleModalCente2"
                          className="badge bg-black mt-4 rounded-pill me-2 d-flex justify-content-center c-pointer align-items-center shadow-5 p-2 my-2"
                        >
                          <small className="ms-1 fs-20 me-2 fw-light text-center">
                            Claim
                          </small>
                        </span>
                      }
                    </>
                  }

                </div>
                <div className="col-md-6 col-xl-6 ">
                  {/* <h4 className="fs-20 text-black my-3">Incoms</h4> */}
                  <div class="card text-white bg-box-1 ">

                    <div class="card-body  mb-0 py-5">
                      <h4 className="fs-20 text-white">Active Stake</h4>
                      <div>
                        <h2 className=" mb-0 font-w600 text-white">{usertnx ? "$" + usertnx : "--"}</h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-xl-6">
                  {/* <h4 className="fs-20 text-black my-3">Statistics</h4> */}

                  <div class="card text-white  bg-box-1">
                    <div class="card-body  mb-0 py-5">
                      <h4 className="fs-20 text-white">Total Stake</h4>
                      <div>
                        <h2 className=" mb-0 font-w600 text-white">{dbuser ? "$" + dbuser?.stake : "--"}</h2>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-xl-6">
                  {/* <h4 className="fs-20 text-black my-3">Statistics</h4> */}

                  <div class="card text-white  bg-box-1">
                    <div class="card-body  mb-0 py-4">
                      <div className="d-flex gap-3 align-items-center mb-2">
                        <h6 className="mb-0 text-white">Next Yield :</h6>
                        <Timer targetDate={dbuser ? formattedDateTime : ""} />
                      </div>
                      <h4 className="fs-20 text-white">Daily Yield</h4>
                      <div>
                        <h2 className=" mb-0 font-w600 text-white mb-3">
                          {DailyReward ? "$" + DailyReward : "--"}
                        </h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6 col-xl-4">
              <div class="card text-white  bg-box-1">
                <div class="card-body  mb-0 py-5">
                  <h4 className="fs-20 text-white">Team Yield</h4>
                  <div>
                    <h2 className=" mb-0 font-w600 text-white">{dbuser ? "$" + dbuser?.levelreward : "--"}</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-4 ">
              {/* <h4 className="fs-20 text-black my-3">Statistics</h4> */}
              <div class="card text-white  bg-box-1">
                <div class="card-body  mb-0 py-5">
                  <h4 className="fs-20 text-white">Pending Claim</h4>
                  <div>
                    <h2 className=" mb-0 font-w600 text-white">{dbbalance ? "$" + dbbalance : "--"}</h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-4 ">
              {/* <h4 className="fs-20 text-black my-3">Statistics</h4> */}
              <div class="card text-white  bg-box-1">
                <div class="card-body  mb-0 py-5">
                  <div className="d-flex gap-3 align-items-center mb-2">
                    <h6 className="mb-0 text-white">Next Claim :</h6>
                    <Timer targetDate={!dbuser ? formattedNextClaimDateTime : ""} />
                    {/* <Timer targetDate={dbuser ? formattedNextClaimDateTime : ""} /> */}
                  </div>
                  <h4 className="fs-20 text-white">Claimed</h4>
                  <div>
                    <h2 className=" mb-0 font-w600 text-white">{Claimed ? "$" + Claimed : "--"}</h2>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-12 ">
              <div className="card  bg-box-1">
                <div className="card-body py-2">
                  <div className="text-center mb-2">
                    <div className="row justify-content-center my-2">
                      <div className="col-4">
                        <h3 className="text-white"> <Timer targetDate={setting ? setting[0]?.to_date : ""} /></h3>
                      </div>
                    </div>
                    <h5 className="mb-0 text-white">Bonanza Reward</h5>
                  </div>
                  <div className="row">
                    {data.bonanzaRewards && data.bonanzaRewards.length > 0 ? (
                      data.bonanzaRewards.map((item, index) => (
                        <div className="col-md-4" key={item._id}>
                          <div className="card mt-3">
                            <div className="card-body pb-0 text-center">
                              {/* Display Level from bonanzaRewards */}
                              <h4 className="fs-20 text-white">Level {item.level}</h4>
                              {/* Display reward from bonanzaRewards */}
                              <h5 className="font-w600 text-white">${item.reward || '--'}</h5>
                              <p className="font-w600 text-white">Reward</p>
                              {/* Display team_business from bonanzaRewards with dollar sign */}
                              <p className="font-w600 text-white">
                                Needed Business: ${item.team_business || '--'}
                              </p>
                              {/* Display level-specific income from levelsIncome */}
                              <p className="font-w600 text-white">
                                Team Business: ${data.levelsIncome[`Level ${item.level}`] || '--'}
                              </p>
                              {/* Check if Team Business is >= Needed Business and display check mark */}
                              {data.levelsIncome[`Level ${item.level}`] >= item.team_business ? (
                                <span className="text-success">&#10003; {/* Check mark */}</span>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p>No data available or data is not in expected format</p>
                    )}
                  </div>{" "}
                </div>
              </div>
            </div>
            <div className="col-xl-12 ">
              <div className="card  bg-box-1">
                <div className="card-header d-block d-sm-flex border-0">
                  <div>
                    <h4 className="fs-20 text-white">Report</h4>
                    {/* <p className="mb-0 fs-12 text-white">
                      Lorem ipsum dolor sit amet, consectetur
                    </p> */}
                  </div>
                  <div className="card-action card-tabs mt-3 mt-sm-0">
                    <div
                      className="nav nav-tabs p-2 d-flex"
                      style={{ overflow: " scroll" }}
                      role="tablist"
                    >
                      <li className="nav-item" onClick={() => setShowTab(0)}>
                        <a
                          className={
                            showtab === 0 ? "nav-link text-white active my-1" : "nav-link text-white  my-1"
                          }
                        >
                          Swap
                        </a>
                      </li>
                      <li className="nav-item" onClick={() => setShowTab(1)}>
                        <a
                          // className="nav-link text-white active my-1"
                          className={
                            showtab === 1 ? "nav-link text-white active my-1" : "nav-link text-white  my-1"
                          }
                        // data-bs-toggle="tab"
                        // href="#Week"
                        // role="tab"
                        >
                          History
                        </a>
                      </li>
                      <li className="nav-item" onClick={() => setShowTab(2)}>
                        <a
                          className={
                            showtab === 2 ? "nav-link text-white active my-1" : "nav-link text-white  my-1"
                          }
                        >
                          Team
                        </a>
                      </li>
                      <li className="nav-item" onClick={() => setShowTab(3)}>
                        <a
                          className={
                            showtab === 3 ? "nav-link text-white active my-1" : "nav-link text-white  my-1"
                          }
                        >
                          Daily Yield
                        </a>
                      </li>
                      <li className="nav-item" onClick={() => setShowTab(4)}>
                        <a
                          className={
                            showtab === 4 ? "nav-link text-white active my-1" : "nav-link text-white  my-1"
                          }
                        >
                          Team Yield
                        </a>
                      </li>
                      <li className="nav-item" onClick={() => setShowTab(5)}>
                        <a
                          className={
                            showtab === 5 ? "nav-link text-white active my-1" : "nav-link text-white  my-1"
                          }
                        >
                          Claim
                        </a>
                      </li>
                      <li className="nav-item" onClick={() => setShowTab(6)}>
                        <a
                          className={
                            showtab === 6 ? "nav-link text-white active my-1" : "nav-link text-white  my-1"
                          }
                        >
                          Bonanza
                        </a>
                      </li>

                    </div>
                  </div>
                </div>
                <div className="card-body pb-0 pt-sm-3 pt-0 tab-content">
                  <div className={
                    showtab === 0 ? "d-block" : "d-none"
                  }>
                    <SwapTable />
                    <div id="chartBarRunning" className="bar-chart" />
                  </div>
                  <div className={
                    showtab === 1 ? "d-block" : "d-none"
                  }>
                    <HistoryTable />
                    <div id="chartBarRunning" className="bar-chart" />
                  </div>
                  <div className={
                    showtab === 2 ? "d-block" : "d-none"
                  }>
                    <TeamTable />
                    <div id="chartBarRunning2" className="bar-chart" />
                  </div>
                  <div className={
                    showtab === 3 ? "d-block" : "d-none"
                  }>
                    <DailyyieldTable />
                    <div id="chartBarRunning3" className="bar-chart" />
                  </div>
                  <div className={
                    showtab === 4 ? "d-block" : "d-none"
                  }>
                    <TeamyieldTable />
                    <div id="chartBarRunning4" className="bar-chart" />
                  </div>
                  <div className={
                    showtab === 5 ? "d-block" : "d-none"
                  }>
                    <ClaimTable />
                    <div id="chartBarRunning5" className="bar-chart" />
                  </div>
                  <div className={
                    showtab === 6 ? "d-block" : "d-none"
                  }>
                    <BonanzaReward />
                    <div id="chartBarRunning6" className="bar-chart" />
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-xl-12 ">
              <div className="card  bg-box-1">
                <div className="card-body py-2">
                  {" "}
                  <div className="d-flex justify-content-around align-items-center flex-wrap">
                    <span class="badge c-pointer rounded-pill me-2 d-flex justify-content-between align-items-center shadow-1 p-2 my-2">
                      <small className="ms-1 fs-15 me-2 fw-light">
                        Add Chain
                      </small>
                    </span>
                    <span class="badge c-pointer rounded-pill me-2 d-flex justify-content-between align-items-center shadow-1 p-2 my-2">
                      <small className="ms-1 fs-15 me-2 fw-light">
                        Add Token
                      </small>
                    </span>
                    <span class="badge c-pointer rounded-pill me-2 d-flex justify-content-between align-items-center shadow-1 p-2 my-2">
                      <small className="ms-1 fs-15 me-2 fw-light">
                        Presentation
                      </small>
                    </span>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <StakeModal />
        <ClaimModal />
      </div>
    </div >
  );
}

export default DashboardMain;